import { createAsyncAction } from "typesafe-actions";
import { RoleDto } from "../dtos/role.dtos";

export const getRolesActions = createAsyncAction(
    'GET_ROLE_REQUEST',
    'GET_ROLE_SUCCESS',
    'GET_ROLE_ERROR',
  )<undefined, RoleDto[], string>();